<template>
    <v-container fluid>
        <v-card class="mb-5 pa-2">
            <card-header :title="$t('colors.texts.title')"></card-header>

            <v-card-text>
                <v-row v-if="color" class="mb-12">
                    <v-col col="12" xs="12" sm="12" md="12" class="text-center">
                        <v-chip class="ma-2" color="grey lighten-2 ">
                            <v-avatar left>
                                <v-icon small>mdi-monitor-cellphone</v-icon>
                            </v-avatar>
                            {{ $t('colors.texts.subtitle') }}
                        </v-chip>
                    </v-col>
                    <v-col
                        class="pa-0 elevation-0"
                        col="12"
                        sx="12"
                        sm="12"
                        md="12"
                    >
                        <v-card>
                            <v-app-bar
                                :style="{
                                    backgroundColor:
                                        color.navigation_background,
                                    marginBottom: '200px',
                                    transitionDuration: '0.1s',
                                }"
                                elevation="0"
                            >
                                <v-toolbar-title>
                                    <v-img
                                        max-width="80px"
                                        :src="
                                            resellerLogo ||
                                                require('@/assets/img/default-logo.png')
                                        "
                                    ></v-img>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>

                                <v-menu
                                    offset-y
                                    v-for="(navbarItem, i) in navbarItems"
                                    :key="i"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            text
                                            :style="{
                                                color: color.navigation_text,
                                            }"
                                            v-on="on"
                                            @click="handleChange"
                                            >{{ navbarItem.title }}</v-btn
                                        >
                                    </template>

                                    <v-list
                                        :style="{
                                            backgroundColor:
                                                color.menu_background,
                                        }"
                                    >
                                        <v-list-item>
                                            <v-row>
                                                <!-- Essa organizacao de rows e cols so existe pra fazer com que títulos fiquem alinhados no topo quando seu número e distinto -->
                                                <v-col
                                                    v-for="(col,
                                                    j) in navbarItem.cols"
                                                    :key="j"
                                                >
                                                    <v-list
                                                        :style="{
                                                            minWidth: '150px',
                                                            backgroundColor:
                                                                color.menu_background,
                                                        }"
                                                    >
                                                        <div>
                                                            <v-list-item-title
                                                                class="pl-2 pr-2 pb-2"
                                                                :style="{
                                                                    color:
                                                                        color.menu_text,
                                                                }"
                                                                >{{
                                                                    col.title
                                                                }}</v-list-item-title
                                                            >
                                                            <v-divider
                                                                class="mb-4"
                                                            ></v-divider>
                                                            <v-list-item-content
                                                                v-for="(item,
                                                                k) in col.items"
                                                                :key="k"
                                                                :style="{
                                                                    color:
                                                                        color.menu_text,
                                                                    borderRadius:
                                                                        '4px',
                                                                }"
                                                                @mouseover="
                                                                    handleMouseOver
                                                                "
                                                                @mouseleave="
                                                                    handleMouseLeave
                                                                "
                                                                class="pl-2 pr-2 hovered caption"
                                                                >{{
                                                                    item
                                                                }}</v-list-item-content
                                                            >
                                                        </div>
                                                    </v-list>
                                                </v-col>
                                            </v-row>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>

                                <v-spacer class="d-none d-sm-block"></v-spacer>
                                <v-btn
                                    :style="{ color: color.navigation_text }"
                                    icon
                                >
                                    <v-icon>mdi-logout-variant</v-icon>
                                </v-btn>
                            </v-app-bar>
                            <div></div>

                            <v-footer padless elevation="0">
                                <v-row
                                    :style="{
                                        backgroundColor: color.menu_background,
                                    }"
                                    justify="center"
                                    no-gutters
                                >
                                    <v-col
                                        v-for="(item, i) in footerItems"
                                        :key="i"
                                        col="3"
                                        sm="3"
                                        md="3"
                                        lg="3"
                                        class="text-center"
                                    >
                                        <v-list
                                            class="pa-2"
                                            :style="{
                                                minWidth: '150px',
                                                backgroundColor:
                                                    color.menu_background,
                                            }"
                                        >
                                            <v-list-item-title
                                                class="pa-2 text-left"
                                                :style="{
                                                    color: color.menu_text,
                                                }"
                                                >{{ item }}</v-list-item-title
                                            >
                                            <v-divider class="mb-4"></v-divider>
                                            <v-list-item-content
                                                :style="{
                                                    color: color.menu_text,
                                                    borderRadius: '4px',
                                                }"
                                                class="pl-2 pr-2 caption text-left"
                                            >
                                                Lorem ipsum dolor sit amet
                                                consectetur adipisicing elit.
                                                Earum, doloremque culpa
                                                inventore corporis reprehenderit
                                                aperiam nisi, omnis optio at
                                                maxime fuga quo est dicta animi
                                                impedit reiciendis, maiores
                                                dolorem eligendi.
                                            </v-list-item-content>
                                        </v-list>
                                    </v-col>

                                    <v-col
                                        class="lighten-2 py-4 text-center white--text"
                                        :style="{
                                            backgroundColor:
                                                color.navigation_background,
                                            transitionDuration: '0.1s',
                                        }"
                                        cols="12"
                                    >
                                        <span
                                            :style="{
                                                color: color.navigation_text,
                                            }"
                                            class="caption"
                                        >
                                            <v-icon
                                                :style="{
                                                    color:
                                                        color.navigation_text,
                                                }"
                                                >mdi-copyright</v-icon
                                            >
                                            {{
                                                $t('colors.texts.copyright', {
                                                    'legal-name':
                                                        reseller.legal_name,
                                                })
                                            }}
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-footer>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-form v-if="color" @submit.prevent="save">
                <v-card-text>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="4">
                            <p class="subtitle-2 text-center">
                                {{
                                    $t(
                                        'colors.texts.colors.navigation-background',
                                    )
                                }}
                            </p>
                            <v-color-picker
                                v-model="color.navigation_background"
                                :mode.sync="colorMode"
                                :hide-mode-switch="true"
                                class="mx-auto"
                            ></v-color-picker>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4">
                            <p class="subtitle-2 text-center">
                                {{ $t('colors.texts.colors.menu-background') }}
                            </p>
                            <v-color-picker
                                v-model="color.menu_background"
                                :mode.sync="colorMode"
                                :hide-mode-switch="true"
                                class="mx-auto"
                            ></v-color-picker>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4">
                            <p class="subtitle-2 text-center">
                                {{
                                    $t(
                                        'colors.texts.colors.highlight-background',
                                    )
                                }}
                            </p>
                            <v-color-picker
                                v-model="color.highlight_background"
                                :mode.sync="colorMode"
                                :hide-mode-switch="true"
                                class="mx-auto"
                            ></v-color-picker>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4">
                            <p class="subtitle-2 text-center">
                                {{ $t('colors.texts.colors.navigation-text') }}
                            </p>
                            <v-color-picker
                                v-model="color.navigation_text"
                                :mode.sync="colorMode"
                                :hide-mode-switch="true"
                                class="mx-auto"
                            ></v-color-picker>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4">
                            <p class="subtitle-2 text-center">
                                {{ $t('colors.texts.colors.menu-text') }}
                            </p>
                            <v-color-picker
                                v-model="color.menu_text"
                                :mode.sync="colorMode"
                                :hide-mode-switch="true"
                                class="mx-auto"
                            ></v-color-picker>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4">
                            <p class="subtitle-2 text-center">
                                {{ $t('colors.texts.colors.highlight-text') }}
                            </p>
                            <v-color-picker
                                v-model="color.highlight_text"
                                :mode.sync="colorMode"
                                :hide-mode-switch="true"
                                class="mx-auto"
                            ></v-color-picker>
                        </v-col>
                    </v-row>
                </v-card-text>
                <form-actions :loadingSave="loading"></form-actions>
            </v-form>
            <template v-else>
                <v-row>
                    <v-col class="text-center">
                        <v-progress-circular
                            :size="50"
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                    </v-col>
                </v-row>
            </template>
        </v-card>
    </v-container>
</template>

<script>
import ColorModel from '@/models/Color'
import CardHeader from '@/components/utils/CardHeader'
import FormActions from '@/components/utils/FormActions'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
    data: () => {
        return {
            color: null,
            loading: false,
            navbarItems: null,
            footerItems: null,
        }
    },

    components: {
        'card-header': CardHeader,
        'form-actions': FormActions,
    },

    mixins: [validationMixin],

    methods: {
        setNavbarItems() {
            let navbarItems = [
                {
                    title: this.$t('colors.texts.navbar-items.titles.t0'),
                    cols: [
                        {
                            title: this.$t(
                                'colors.texts.navbar-items.subtitles.s0',
                            ),
                            items: [
                                this.$t('colors.texts.navbar-items.items.i0'),
                                this.$t('colors.texts.navbar-items.items.i1'),
                                this.$t('colors.texts.navbar-items.items.i2'),
                                this.$t('colors.texts.navbar-items.items.i3'),
                            ],
                        },
                        {
                            title: this.$t(
                                'colors.texts.navbar-items.subtitles.s1',
                            ),
                            items: [
                                this.$t('colors.texts.navbar-items.items.i4'),
                                this.$t('colors.texts.navbar-items.items.i5'),
                                this.$t('colors.texts.navbar-items.items.i6'),
                            ],
                        },
                    ],
                },
                {
                    title: this.$t('colors.texts.navbar-items.titles.t1'),
                    cols: [
                        {
                            title: this.$t(
                                'colors.texts.navbar-items.subtitles.s2',
                            ),
                            items: [
                                this.$t('colors.texts.navbar-items.items.i7'),
                                this.$t('colors.texts.navbar-items.items.i8'),
                                this.$t('colors.texts.navbar-items.items.i9'),
                            ],
                        },
                    ],
                },
                {
                    title: this.$t('colors.texts.navbar-items.titles.t2'),
                    cols: [
                        {
                            title: this.$t(
                                'colors.texts.navbar-items.subtitles.s3',
                            ),
                            items: [
                                this.$t('colors.texts.navbar-items.items.i10'),
                                this.$t('colors.texts.navbar-items.items.i11'),
                                this.$t('colors.texts.navbar-items.items.i12'),
                            ],
                        },
                    ],
                },
                {
                    title: this.$t('colors.texts.navbar-items.titles.t3'),
                    cols: [
                        {
                            title: this.$t(
                                'colors.texts.navbar-items.subtitles.s4',
                            ),
                            items: [
                                this.$t('colors.texts.navbar-items.items.i13'),
                                this.$t('colors.texts.navbar-items.items.i14'),
                                this.$t('colors.texts.navbar-items.items.i15'),
                                this.$t('colors.texts.navbar-items.items.i16'),
                            ],
                        },
                        {
                            title: this.$t(
                                'colors.texts.navbar-items.subtitles.s5',
                            ),
                            items: [
                                this.$t('colors.texts.navbar-items.items.i17'),
                            ],
                        },
                        {
                            title: this.$t(
                                'colors.texts.navbar-items.subtitles.s6',
                            ),
                            items: [
                                this.$t('colors.texts.navbar-items.items.i18'),
                                this.$t('colors.texts.navbar-items.items.i19'),
                            ],
                        },
                    ],
                },
            ]

            this.navbarItems = navbarItems
        },

        setFooterItems() {
            let footerItems = [
                this.$t('colors.texts.footer-items.titles.t0'),
                this.$t('colors.texts.footer-items.titles.t1'),
                this.$t('colors.texts.footer-items.titles.t2'),
            ]

            this.footerItems = footerItems
        },

        async save() {
            this.loading = true

            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('colors.bus.save-error'),
                )

                this.loading = false
                return
            }

            let res = null
            let color = this.color.clone()

            try {
                res = await color.save()
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('colors.bus.save-success'),
            )

            this.loading = false
        },

        async getColor() {
            let color = await this.model.find(1)

            if (!color) return

            this.color = color

            this.loading = false
        },

        handleMouseOver(e) {
            e.target.style.backgroundColor = this.color.highlight_background
            e.target.style.color = this.color.highlight_text
        },

        handleMouseLeave(e) {
            e.target.style.backgroundColor = this.color.menu_background
            e.target.style.color = this.color.menu_text
        },

        handleChange() {
            let items = document.getElementsByClassName('hovered')
            if (items.length > 0) {
                for (let i = 0; i < items.length; i++) {
                    items[i].style.backgroundColor = this.color.menu_background
                    items[i].style.color = this.color.menu_text
                }
            }
        },
    },

    validations: {
        color: {
            navigation_background: { required },
            menu_background: { required },
            highlight_background: { required },
            navigation_text: { required },
            menu_text: { required },
            highlight_text: { required },
        },
    },

    created() {
        this.getColor()
        this.setNavbarItems()
        this.setFooterItems()
    },

    computed: {
        resellerLogo() {
            let reseller = this.$store.getters['reseller/reseller']

            return reseller.brand.logo ? reseller.brand.logo_url : null
        },

        navigationBackgroundErrors() {
            const errors = []
            if (!this.$v.color.navigation_background.$dirty) return errors

            !this.$v.color.navigation_background.required &&
                errors.push(
                    this.$t(
                        'colors.messages.navigation-background-error-required',
                    ),
                )
            return errors
        },

        menuBackgroundErrors() {
            const errors = []
            if (!this.$v.color.menu_background.$dirty) return errors

            !this.$v.color.menu_background.required &&
                errors.push(
                    this.$t('colors.messages.menu-background-error-required'),
                )
            return errors
        },

        highlightBackgroundErrors() {
            const errors = []
            if (!this.$v.color.highlight_background.$dirty) return errors

            !this.$v.color.highlight_background.required &&
                errors.push(
                    this.$t(
                        'colors.messages.highlight-background-error-required',
                    ),
                )
            return errors
        },

        navigationTextErrors() {
            const errors = []
            if (!this.$v.color.navigation_text.$dirty) return errors

            !this.$v.color.navigation_text.required &&
                errors.push(
                    this.$t('colors.messages.navigation-text-error-required'),
                )
            return errors
        },

        menuTextErrors() {
            const errors = []
            if (!this.$v.color.menu_text.$dirty) return errors

            !this.$v.color.menu_text.required &&
                errors.push(this.$t('colors.messages.menu-text-error-required'))
            return errors
        },

        highlightTextErrors() {
            const errors = []
            if (!this.$v.color.highlight_text.$dirty) return errors

            !this.$v.color.highlight_text.required &&
                errors.push(
                    this.$t('colors.messages.highlight-text-error-required'),
                )
            return errors
        },

        model() {
            return new ColorModel()
        },

        colorMode() {
            return 'hexa'
        },

        reseller() {
            return this.$store.getters['reseller/reseller']
        },
    },
}
</script>
